import { render } from "./context.vue?vue&type=template&id=22f831d8"
import script from "./context.vue?vue&type=script&lang=js"
export * from "./context.vue?vue&type=script&lang=js"

import exportComponent from "/app/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__